import React from 'react';
import SearchMap from './SearchMap';

export const SearchMapSplitter = (props: any) => {
    const { ...mapProps } = props;

    return <SearchMap {...mapProps} />;
};

export default SearchMapSplitter;
